export enum PAGE_TYPE {
    page = 'page',
    result_info = 'result_info',
}
